<template>
  <div class="emailService">
    <div class="search">
     <el-row>
      <el-col :span="18">
        <div class="emailNum">
          邮件送达总数
        </div>
      </el-col>
      <el-col :span="6">
        <el-input v-model="email" placeholder="请输入要搜索的邮箱" prefix-icon="el-icon-search" size="small" @keydown.enter.native="searchData" clearable></el-input>
      </el-col>
     </el-row>
    </div>
    <div class="tableList">
      <el-table
      class="fine-scroll-bar"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        :height="$store.state.userInfo.loginAsManagerId>0?'calc(100vh - 290px)':'calc(100vh - 245px)'"
        v-loading="loading"
        >
        <template slot="empty">
          <div class="emptycontent">
            <div class="emptycontentDiv">
              <div class="emptycontentimg">
                <img src="@/assets/image/common/mailnoData.png" alt="">
              </div>
              <div class="emptyText">
                暂无数据
              </div>
            </div>
          </div>
        </template>
        <!-- 发送历史 -->
        <el-table-column
          prop="name"
          label="发送历史"
          align="center"
          width="88px"
        >
          <template slot-scope="scope">
            <div class="iconDiv">
              <i @click="history(scope)" class="iconfont icon-icon-xinxi"></i>
            </div>
          </template>
        </el-table-column>
        <!-- 生成日期 -->
        <el-table-column
          prop="createTime"
          label="生成日期"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span >
              {{scope.row.createTime | format('YYYY-MM-DD HH:mm:ss')}}
            </span>
          </template>
        </el-table-column>
        <!-- 收件人邮箱 -->
        <el-table-column
          prop="receiptEmail"
          label="收件人邮箱"
          show-overflow-tooltip>
          <template slot-scope="scope">
            <span>
              {{scope.row.receiptEmail | noText}}
            </span>
          </template>
        </el-table-column>
        <!-- 主题 -->
        <el-table-column
          prop="title"
          label="主题"
          show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span>
              {{scope.row.title | noText}}
            </span>
          </template>
        </el-table-column>
        <!-- 回复邮箱 -->
        <el-table-column
          prop="replyEmail"
          label="回复邮箱"
          show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span>
              {{scope.row.replyEmail | noText}}
            </span>
          </template>
        </el-table-column>
        <!-- 发件人邮箱 -->
        <el-table-column
          prop="sendEmail"
          label="发件人邮箱"
          show-overflow-tooltip
          >
          <template slot-scope="scope">
            <span>
              {{scope.row.sendEmail | noText}}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagetionStyle"> 
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="curPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes,prev,pager,next, jumper"
          :total="totalNum"
          ref="pagina"
          >
        </el-pagination>
      </div>
    </div>

    <div>
      <el-dialog
        title="历史"
        :visible.sync="dialogVisible"
        width="30%"
        custom-class="historyDialog"
        :destroy-on-close="true"
        >
        <div class="dialogDetail">
          <div class="title">
            历史  {{receiptEmail}}
          </div>
          <div class="explain">
            <i class="iconfont icon-icon-tishi"></i> 该概况只是显示此收件人的过去24个月中的历史记录
          </div>
          <div>
            <el-table
            class="fine-scroll-bar"
              :data="historyTableData"
              tooltip-effect="dark"
              style="width: 100%"
              :default-sort = "{prop: 'datetime', order: 'descending'}"
              height="200"
              @sort-change="sortchange"
              >
              <!-- 生成日期 -->
              <el-table-column
                prop="datetime"
                label="生成日期"
                :sortable="'custom'"
                >
                  <template slot-scope="scope">
                    <div >
                      {{scope.row.datetime | format('YYYY-MM-DD HH:mm:ss') }}
                    </div>
                  </template>
              </el-table-column>
              <!-- 发送主题 -->
              <el-table-column
                prop="title"
                label="发送主题">
                  <template slot-scope="scope">
                    <div>
                      {{scope.row.title | noText}}
                    </div>
                  </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false" size="">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span> -->
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {querySuccesspage,queryHistory} from "@/utils/api/edmSubject"
export default {
  data(){
    return{
      totalNum:0,
      pageSize:10,
      curPage:1,
      tableData: [],
      multipleSelection: [],
      dialogVisible:false,
      email:'',
      historyTableData:[],
      receiptEmail:'',
      sortType:2,
      defaultSort : {prop: 'datetime', order: 'descending'},
      loading:false
    }
  },
  mounted(){
    this.getquerySuccesspage()
  },
  methods:{
    // 翻页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize=val
      this.handleCurrentChange(1)
      this.clickPage=1
    },
    // 当前页
    handleCurrentChange(val) {
      this.curPage=val
      this.getquerySuccesspage()
    },
    // 表格选中
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
      // this.multipleSelectionId=[]
      // this.multipleSelection.map(item=>{
      //   this.multipleSelectionId.push(item.contactId)
      // })
      // console.log(itemArr.join())
      // this.multipleSelectionId=itemArr.join()
    },
    history(scope){
      this.dialogVisible=true
      this.receiptEmail=scope.row.receiptEmail
      this.defaultSort = {prop: 'datetime', order: 'descending'}
      this.sortType=2
      this.getqueryHistory()
    },
    // 排序
    sortchange({ column, prop, order }){
      console.log({ column, prop, order })
      if(order=='ascending'){
        this.sortType=1
      }else if(order=='descending'){
        this.sortType=2
      }else{
        this.sortType=0
      }
      this.getqueryHistory()
    },
    // 获取数据
    async getquerySuccesspage(){
      this.loading=true
      const prams={
        pageSize:this.pageSize,
        curPage:this.curPage,
        email:this.email,
        attribute:'',
        sortType:''
      }
      const res =await querySuccesspage(prams)
      this.tableData=res.rspPageData.list
      this.totalNum=res.rspPageData.totalNum
      this.loading=false
    },
    // 获取历史列表
    async getqueryHistory(){
      const parms={
        email:this.receiptEmail,
        sortType:this.sortType
      }
      const res=await queryHistory(parms)
      this.historyTableData=res.rspListData.list
    },
    async searchData(e){
      if(e.keyCode==13){
        this.handleSizeChange(10)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.pagetionStyle{
  text-align: center;
  margin-top: 20px;
  ::v-deep .is-background{
    .btn-prev,.btn-next,.el-pager>li{
      background: #FFFFFF;
      border: 1px solid #CFD5DF;
      border-radius: 6px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active{
      background-color: #066EB7 !important;
    }
    // .btn-prev{
    //   background: #FFFFFF;
    //   border: 1px solid #CFD5DF;
    //   border-radius: 6px;
    // }
  }
}
.divBtn{
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  color: #066EB7;
  cursor: pointer;
}
.emailService{
  // padding-left: 24px;
  // margin-top: 40px;
}
.iconDiv{
  cursor: pointer;
  .iconfont{
    color: #066EB7;
    font-size: 14px;
  }
}
::v-deep .historyDialog{
  .el-dialog__header{
    .el-dialog__title{
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181A;
    }
  }
  .el-dialog__body{
    padding: 0px 20px 20px 20px;
  }
  .dialogDetail{
    .title{
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #16181A;
    }
    .explain{
      background: rgba(6,110,183,.1);
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #066EB7;
      height: 36px;
      line-height: 36px;
      padding-left: 16px;
      margin-top: 11px;
      margin-bottom: 16px;
      .iconfont{
        font-size: 12px;
      }
    }
  }
}
::v-deep .search{
    padding: 8px 20px;
    background: #F5F7FA;
    line-height: 36px;
  .emailNum{
    font-family: SourceHanSansCN-Medium;
    font-weight: 500;
    font-size: 14px;
    color: #16181A;
  }
  .el-input--small .el-input__inner{
    border: none;
  }
}
.tableList{
  padding: 20px;
  .emptycontent{
    min-height: 280px;
    .emptycontentDiv{
      // margin-top: calc(518 / 1200 * 100%);
      .emptycontentimg{
        width: 300px;
        height: 180px;
        // background: gray;
        margin: 0 auto;
        // margin-top: 200px;
        img{
          width: 100%;
          height: 100%;
        }
        // margin-bottom: 200px;
      }
      .emptyText{
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 14px;
        color: #4F5D78;
        line-height: 20px;
        // margin-bottom: 200px;
      }
    }

  }
}

::v-deep .fine-scroll-bar {
    .el-table__body-wrapper{
    scrollbar-width: thin !important;//滚动条变细，为none时隐藏滚动条
    // 更改滚动条样式
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: hsla(0, 0%, 53%, 0.4);
      border-radius: 4px;
    }

    &::-webkit-scrollbar-track {
      background: hsla(0, 0%, 53%, 0.1);
    }
  }
}

</style>